<template>
    <b-container fluid id="notLoggedInContainer">
      <b-jumbotron header="Welcome to RxPave" lead="Selecting rehabilitation strategies for low-volume roads">
        <p> RxPave is a decision-support app that evaluates pavement treatment strategies for distressed, low-volume roads where expertise is limited </p>
        <b-button variant="primary" class="mr-3" to="signup">Sign Up</b-button>
        <!--<b-button variant="secondary" v-on:click="startLogin()">Login</b-button>-->
        <b-button variant="secondary" v-b-modal.login-modal>Login</b-button>
      </b-jumbotron>

      <!--<login-modal v-if="showModal" @close="showModal=false" >-->
      <!--</login-modal>-->
      <!--<login-modal></login-modal>-->
    </b-container>
</template>

<script>
  import LoginModal from './../LoginModal.vue'
	export default {
		name: "Home",
    components: {
		  LoginModal
    },
    data: function() {
		  return {
		    showModal: false
      }
    },
    methods:{
		  startLogin(){
		    this.showModal = true;
      }
    }
	}
</script>

<style scoped>

</style>